var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#ECEFF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_623_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 4L15.845 4.52414V19.7321L15.9979 19.886L22.9957 15.7133L15.9979 4Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 4L9 15.7133L15.9979 19.886V12.5045V4Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 21.2226L15.9117 21.3286V26.7459L15.9979 26.9998L23 17.052L15.9979 21.2226Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 26.9998V21.2226L9 17.052L15.9979 26.9998Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 19.886L22.9957 15.7133L15.9979 12.5045V19.886Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.7133L15.9979 19.886V12.5045L9 15.7133Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_623_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 23,
    fill: "white",
    transform: "translate(9 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ETH.6230926549fc63004dfa68bc0bc63d34.svg";